/* eslint no-param-reassign: "error" */

import Vue from 'vue';

export default {
  SET_TOKEN(state, response) {
    let decode = {};
    let validExp = false;
    if (response.token !== null && response.token !== 'undefined') {
      decode = Vue.jwtDec.decode(response.token);
      validExp = decode.exp > +new Date() / 1000;
      localStorage.setItem('access_token', response.token);
      localStorage.setItem('role', response.role);
      localStorage.setItem('useRole', response.useRole);
    }
    state.isAuthenticated = !!response.token && validExp;
    state.tokenExpires = decode.exp ? decode.exp * 1000 : 0;
  },

  CLEAR_TOKEN(state) {
    state.isAuthenticated = false;
    state.tokenExpires = 0;
    localStorage.removeItem('access_token');
    localStorage.removeItem('role');
    localStorage.removeItem('useRole');
  },

  CHECK_TOKEN(state) {
    const token = localStorage.getItem('access_token');
    let decode = {};
    let validExp = false;
    if (token !== null && token !== 'undefined') {
      decode = Vue.jwtDec.decode(token);
      validExp = decode.exp > +new Date() / 1000;
    }
    state.isAuthenticated = !!token && validExp;
    state.tokenExpires = decode.exp ? decode.exp * 1000 : 0;
  },
};
